import { useEffect, useState } from 'react';
import {
  isSingleThemeMode,
  subscribeSingleThemeMode,
} from './singleTheme';

/**
 * React-aware read of single-theme mode (RegSource / `single-theme-release`).
 * The V3 shell owns the PostHog flag; this hook stays in sync when the shell
 * flips mode via `__v3singleTheme` / THEME_CHANGED → `setSingleThemeMode`.
 */
export function useIsSingleTheme(): boolean {
  const [singleTheme, setSingleTheme] = useState(() => isSingleThemeMode());

  useEffect(() => subscribeSingleThemeMode(setSingleTheme), []);

  return singleTheme;
}
